import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import { useNavigate } from "react-router";
import { CreativeContext } from "./CreativeCreation";
import { SlProgressBar } from "@shoelace-style/shoelace/dist/react";

function NewsImageLogo({
  company,
  companyName,
  handleshow,
  // advId,
  creative_name,
  creative_type,
  subtype,
  editdata,
  flag,
  handlesubmit,
  createdEdited,
}) {
  const navigate = useNavigate();

  const { preview, setPreview } = useContext(CreativeContext);
  const [progress, setProgress] = useState(0);

  const [inputFields, setInputFields] = useState([
    {
      img_id: "0",
      image: "",
    },
  ]);
  const [processingIndex, setProcessingIndex] = useState(-1);

  const webviewPositions = [
    { label: "Top Left", value: "1" },
    { label: "Top Right", value: "2" },
    { label: "Middle Left", value: "3" },
    { label: "Middle Right", value: "4" },
    { label: "Bottom Left", value: "5" },
    { label: "Bottom Right", value: "6" },
  ];
  
  const imageChange = async (e, index) => {
    if (e.target.files && e.target.files.length > 0) {
      imageUrl(e.target.files[0], index);
      setProcessingIndex(index);
    } else {
      if (flag === "edit") {
        if (editdata.gallery[index]) {
          const values = [...inputFields];
          values[index].image = editdata.gallery[index].image;
          setInputFields(values);
          const { gallery } = preview;
          gallery[index] = editdata.gallery[index]?.image;
          setPreview({ ...preview, gallery: gallery });
        } else {
          setProgress(0);
          setValue(`image${index}`, "");
          const values = [...inputFields];
          values[index].image = "";
          setInputFields(values);
          const { gallery } = preview;
          gallery[index] = "";
          setPreview({ ...preview, gallery: gallery });
        }
        console.log(preview);
      } else {
        setProgress(0);
        setValue(`image${index}`, "");
        const values = [...inputFields];
        values[index].image = "";
        setInputFields(values);
        const { gallery } = preview;
        gallery[index] = "";
        setPreview({ ...preview, gallery: gallery });
      }
      console.log(preview);
    }
  };

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
    getValues,
  } = useForm({ mode: "onSubmit" });
  const imageUrl = async (imgFile, index) => {
    try {
      const formData = new FormData();
      formData.append("files", imgFile);
      let url = await api({
        url: `/upload/brandLogo`,
        method: "POST",
        responseType: "json",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (data) => {
          setProgress(Math.round((100 * data.loaded) / data.total));
        },
      });
      if (url.code === 200) {
        let values = [...inputFields];
        values[index].image = url.data.data;
        setInputFields(values);
        const { gallery } = preview;
        gallery[index].image = url.data.data;
        values[index].img_id = `${index}`;
        setPreview({ ...preview, gallery: gallery });
      } else {
        setProgress(0);
        setValue(`image${index}`, "");
        Toast("error", url.data.message);
      }
    } catch (error) {
      Toast("error", error);
    }
  };
  const handleAdd = () => {
    if (inputFields.length < 4) {
      setInputFields([
        ...inputFields,
        {
          image: "",
        },
      ]);
      const { gallery } = preview;
      gallery.push({image:""});
    } else {
      Toast("error", "Maximum limit of 4 Images exceeded");
    }
  };
  const position = watch("position",'');
  const handleRemove = (index) => {
    setValue(`image${index}`, "");
    const values = [...inputFields];
    values.splice(index, 1);
    if (editdata.gallery && editdata.gallery[index]) {
      editdata.gallery.splice(index, 1);
    }
    setInputFields(values);
    const { gallery } = preview;
    gallery.splice(index, 1);
    setPreview({ ...preview, gallery: gallery });
  };

  useEffect(() => {
    if (flag === "edit") {
        let gallery = JSON.parse(JSON.stringify(editdata.gallery));
        setInputFields(gallery);
      setPreview({
        ...preview,
        sub_type: editdata.sub_type,
        gallery: gallery,
        position: `${editdata.position}`,
        shuffle: `${editdata.shuffle}`,
      });
    }
    else{
        setPreview({
          ...preview,
          sub_type: subtype,
          gallery: inputFields,
        });
    }
  }, [company]);

  useEffect(()=>{
    if(flag==="edit"){
      console.log(editdata);
      setValue("show_webview",editdata.video_urls ? "1" : "0")
      setValue("webviewurl",editdata.video_urls)
      setValue("webviewgif", editdata.text_in_link)
      setValue("defaultwebpreview",`${editdata.center}`)
      setValue("position",`${editdata.position}`)
      setValue("shuffle",editdata.shuffle ? "1" : "0")
      setPreview({...preview,show_webview:editdata.video_urls ? "1" : "0",position:editdata.position,shuffle:editdata.shuffle ? "1" : "0" })
    }
  },[])

  const onSubmit = async (data) => {
    if(inputFields.length < 1) {
      Toast("error", "Please add atleast one image");
      return;
    } 
    if (flag === "add") {
      handlesubmit(true);
      let obj = {
        company_id: company,
        company_name: companyName,
        // adv_id: advId,
        creative_name,
        creative_type,
        sub_type: subtype,
        clickurl: data.clickurl,
        position:data.position,
        rotation:data.show_webview ? false: (data.shuffle || inputFields.length > 1 ? true : false),
        gallery : data.show_webview ? [inputFields[0]] : inputFields,
        impurl: { primary: data.impurl, secondary: data.impurl1 },
        video_urls: data.show_webview ? data.webviewurl : "",
        text_in_link:data.show_webview ? data.webviewgif : "",
        center:data.show_webview ? data.defaultwebpreview : 0
      };
      // if (advId !== "" && creative_name !== "") {
      if (creative_name !== "") {
        try {
          let res = await api({
            url: `/creatives/brandad/news-logo`,
            method: "POST",
            responseType: "json",
            data: obj,
          });
          if (res?.code === 200) {
            Toast("success", " Creative Created Successfully  ");
            handleshow(false);
            createdEdited(true);
          } else {
            Toast("error", res.data.message);
          }
        } catch (error) {
          console.error(error);
          if (error.response.status === 401) navigate("/");
        }
      }
    } else if (flag === "edit") {
      let obj = {
        creative_name: creative_name,
        creative_id: editdata.creative_id,
        clickurl: data.clickurl,
        position:data.position || editdata.position,
        impurl: { primary: data.impurl, secondary: data.impurl1 },
        rotation: (data.shuffle == '1' || (!data.show_webview && inputFields.length > 1)) || false,
        gallery : data.show_webview ? [inputFields[0]] : inputFields,
        video_urls: data.show_webview ? data.webviewurl || editdata.video_urls : "",
        text_in_link: data.show_webview ? data.webviewgif || editdata.text_in_link : "",
        center:data.show_webview ? data.defaultwebpreview : 0,
      };
      try {
        let res = await api({
          url: `/creatives/brandad/edit-news-logo`,
          method: "POST",
          responseType: "json",
          data: obj,
        });
        if (res?.code === 200) {
          Toast("success", " Creative Edited Successfully  ");
          handleshow(false);
          createdEdited(true);
        } else {
          Toast("error", res.data.message);
        }
      } catch (error) {
        console.error(error);
        if (error.response.status === 401) navigate("/");
      }
    }
  };

  return (
    <>
      <div className="row">
        <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
          <div className="row">
            <section className="col-12">
            <div className="form-check my-3">
          <input
            className="form-check-input"
            type="checkbox"
            id="showWebview"
            {...register("show_webview")}
            checked={preview.show_webview ==="1"}
            onChange={(e) => {
              // setValue("defaultwebpreview",'0')
              // setValue("position", '');
              setValue("shuffle",'0')
              setPreview({
                ...preview,
                shuffle: '0',
                show_webview: e.target.checked ? '1' : '0',
              })
            }}
          />
          <label className="form-check-label" htmlFor="showWebview">
            Show Webview
          </label>
        </div>

        {preview.show_webview === '1' && <><div className="col mb-3">
                  <label className="form-label">
                    WebView URL
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("webviewurl", {
                      required: preview.show_webview ==='1' ,
                      pattern: {
                        value:
                          /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                        message: "Enter a Valid URL",
                      },
                    })}
                  />
                  {errors.webviewurl && (
                    <p className="text-red-600">{errors.webviewurl.message || "Please Enter a Webview Url"}</p>
                  )}
        </div>
        <div className="col mb-3">
        <label className="form-label">
          WebView GIF (Ios)
        </label>
        <input
          type="text"
          className="form-control"
          {...register("webviewgif", {
            required: preview.show_webview ==='1' ,
            pattern: {
              value:
                /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*)\.gif))/,
              message: "Enter a Valid URL",
            },
          })}
        />
        {errors.webviewgif && (
          <p className="text-red-600">{errors.webviewgif.message || "Please Enter a Webview GIF"}</p>
        )}
</div></>}
            <div>
                <div>
                  {inputFields?.map((inputField, index) => (
                    <>
                      <label className="form-label" key={`label${index}`}>
                        Image
                      </label>
                      <br />
                      <span>(Image width should be greater than height )</span>
                      <div className="input-group mb-3" key={`img${index}`}>
                        <input
                          className="form-control "
                          type="file"
                          id="formFile"
                          name="files"
                          {...register(`image${index}`, {
                            required:
                              inputFields[index].image !== "" ? false : true,
                            onChange: (e) => imageChange(e, index),
                          })}
                        />
                        <div className="input-group-append">
                          <button
                            type="button"
                            className="btn btn-outline-danger"
                            onClick={() => handleRemove(index)}
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                      {errors[`image${index}`] && (
                        <p className="text-red-600">Image is mandatory</p>
                      )}
                      {processingIndex === index &&
                      progress > 0 &&
                      progress < 100 ? (
                        <SlProgressBar value={progress}>
                          {progress}%
                        </SlProgressBar>
                      ) : inputFields[index].image !== "" ? (
                        <span>{`${inputField.image}`}</span>
                      ) : (
                        flag === "edit" && <span>{`${inputField.image}`}</span>
                      )}
                      <br></br>
                    </>
                  ))}
                </div>
              {preview.show_webview === '0' &&  <div className="flex justify-end">
                  <button
                    type="button"
                    name="add"
                    className="btn btn-primary"
                    onClick={() => handleAdd()}
                  >
                    Add
                  </button>
                </div>}
              </div>

              <div className="row mb-3">
                <div className="col">
                  <label className="form-label">
                    Click URL / Mobile Number
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={editdata.click_url}
                    name="clickurl"
                    {...register("clickurl", {
                      required: false,
                      pattern: {
                        value:
                          /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)|^(0\d{10}|[6-9]\d{9})$/,
                        message: "Enter a Valid URL or Mobile Number",
                      },
                    })}
                  />
                  {errors.clickurl && (
                    <p className="text-red-600">{errors.clickurl.message}</p>
                  )}
                </div>
                <div className="col">
                  <label className="form-label">Impression URL - Primary</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={
                      editdata.impression_tracking_url
                        ? editdata.impression_tracking_url.primary
                        : null
                    }
                    {...register("impurl", {
                      required: false,
                      pattern: {
                        value:
                          /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                        message: "Enter a Valid URL",
                      },
                    })}
                  />
                  {errors.impurl && (
                    <p className="text-red-600">{errors.impurl.message}</p>
                  )}
                </div>
                <div className="col">
                  <label className="form-label">
                    Impression URL - Secondary
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={
                      editdata.impression_tracking_url
                        ? editdata.impression_tracking_url.secondary
                        : null
                    }
                    {...register("impurl1", {
                      required: false,
                      pattern: {
                        value:
                          /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                        message: "Enter a Valid URL",
                      },
                    })}
                  />
                  {errors.impurl1 && (
                    <p className="text-red-600">{errors.impurl1.message}</p>
                  )}
                </div>
              </div>


        <div>
          <h6>Logo Position</h6>

          {(preview.show_webview === '1' ? webviewPositions : [
            { label: "Top Left", value: "1" },
            { label: "Top Right", value: "2" },
          ]).map((pos) => (
            <div className="form-check form-check-inline" key={pos.value}>
              <input
                className="form-check-input"
                type="radio"
                id={`position-${pos.value}`}
                value={pos.value}
                {...register("position", { required: true })}
                checked={preview.position == (pos.value)}
                onChange={() =>{
                  setValue("position",(pos.value))
                  setPreview({ ...preview, position: (pos.value) })
                }}
              />
              <label className="form-check-label" htmlFor={`position-${pos.value}`}>
                {pos.label}
              </label>
            </div>
          ))}
          {errors?.position &&  !preview?.position && (
            <p className="text-red-600">Please select a position</p>
          )}
          <div>
          {preview.show_webview === '1' ? (<>
          <h6>Select Action</h6>
            <div className="form-check form-check-inline">
  <input
    className="form-check-input"
    type="radio"
    id="redirect"
    value="0"
    {...register("defaultwebpreview", { required: true })}
    onChange={(e) =>
      setPreview({ ...preview, defaultwebpreview: e.target.value })
    }
  />
  <label className="form-check-label" htmlFor="redirect">
    No Action
  </label>
</div><div className="form-check form-check-inline">
  <input
    className="form-check-input"
    type="radio"
    id="defaultwebpreview"
    value="1"
    {...register("defaultwebpreview", { required: true })}
    onChange={(e) =>
      setPreview({ ...preview, defaultwebpreview: e.target.value })
    }
  />
  <label className="form-check-label" htmlFor="defaultwebpreview">
    Default WebPreview
  </label>
</div>

<div className="form-check form-check-inline">
  <input
    className="form-check-input"
    type="radio"
    id="redirect"
    value="2"
    {...register("defaultwebpreview", { required: true })}
    onChange={(e) =>
      setPreview({ ...preview, defaultwebpreview: e.target.value })
    }
  />
  <label className="form-check-label" htmlFor="redirect">
    Redirect
  </label>
</div></>
) : (<div className="form-check">
                <input
                  className="form-check-input"
                  id="Rotation"
                  type="checkbox"
                  checked={preview.shuffle == '1' ? true : false}
                  {...register("shuffle", { required: false })}
                  onChange={(e) => {console.log(e.target.checked); setPreview({...preview, shuffle: e.target.checked ? '1' : '0'})}}
                />
                <label className="form-check-label" htmlFor="Rotation">
                  Rotation
                </label>
              </div>) }</div>
        </div>
              <div className="my-3 text-end">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={progress > 0 && progress < 100 ? true : false}
                >
                  Save Creative
                </button>
              </div>
            </section>
          </div>
        </form>
      </div>
    </>
  );
}

export default NewsImageLogo;
